export const hidden_frame_id = 'progress-container';
export const challenge_frame_id = 'challenge-container';

export const challenge_container_class = 'process-payment--challenge';
